export const siteContent = {
  professionalName: 'Profissional',
  publicLocation: 'Atendimento online e presencial',
  eyebrow: 'Atendimento terapêutico',
  headline: 'Um espaço de escuta, presença e transformação.',
  introduction:
    'Conheça os atendimentos, consulte informações e verifique horários pela Terapeut-IA®.',
  about:
    'Este espaço será atualizado pela profissional no Estúdio da Terapeuta.',
  faq: [
    {
      question: 'Como consultar horários?',
      answer: 'Abra a Terapeut-IA® no canto da tela e escolha a opção de consulta de agenda.',
    },
    {
      question: 'Como falar diretamente com a profissional?',
      answer: 'Use o botão de WhatsApp. A mensagem será aberta para revisão antes do envio.',
    },
  ],
}
